import axios from "axios";

const baseURL =
  import.meta.env.VITE_APP_ENV === "production"
    ? import.meta.env.VITE_BASE_URL
    : import.meta.env.VITE_APP_ENV === "development"
    ? import.meta.env.VITE_BASE_URL_DEV
    : import.meta.env.VITE_BASE_URL_LOCAL;

const adminBaseURL =
  import.meta.env.VITE_APP_ENV === "production"
    ? import.meta.env.VITE_ADMIN_URL
    : import.meta.env.VITE_APP_ENV === "development"
    ? import.meta.env.VITE_ADMIN_URL_DEV
    : import.meta.env.VITE_ADMIN_URL_LOCAL;

const axiosInstance = axios.create({
  baseURL,
});

const adminAxiosInstance = axios.create({
  baseURL: adminBaseURL,
});

let intercept = (config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    //  } else if (localStorage.getItem('refresh')) {
    //    let refreshToken = localStorage.getItem('refresh');
    //    let prevToken = localStorage.getItem('prev_token');
    //    let tokens = new Promise(async(resolve, reject)=>{
    //      let new_token = await axiosInstance.post('/auth/refresh-tokens',{refreshToken}, {headers:{"Authorization":"Bearer "+prevToken}})
    //      resolve(new_token);
    //    })
    //    console.log(tokens)
    //    let { access, refresh } = tokens;
    //    localStorage.setItem('token', access.token)
    //    localStorage.setItem('refresh', refresh.token)
    //    config.headers.Authorization = `Bearer ${access.token}`;
    //  } else {

    //  window.location.href = '/auth/login';
  }
  return config;
};

const interceptAxios = (instance) => {
  instance.interceptors.request.use(intercept);

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        "response" in error &&
        "status" in error.response &&
        error.response.status === 401
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("store");
        window.location.href = "/auth/login";
      }
      else if("response" in error &&
        "status" in error.response &&
        error.response.status === 403) {
        window.location.href = "/auth/403";
        }
      return error;
    }
  );
};

interceptAxios(axiosInstance);
interceptAxios(adminAxiosInstance);

export { adminAxiosInstance, axiosInstance, baseURL };
